const locale = {
	VIEW_ACTIVITIES_TAB_KANBAN: 'Kanban',

	// #region Activities fields
	DETAILS_ACTIVITIES_FIELD_TITLE: 'Title',
	DETAILS_ACTIVITIES_FIELD_STATUS: 'Activity Status',
	DETAILS_ACTIVITIES_FIELD_TYPE: 'Activity Type',
	DETAILS_ACTIVITIES_FIELD_COMPANY: 'Company',
	DETAILS_ACTIVITIES_FIELD_PERSON: 'External Contact',
	DETAILS_ACTIVITIES_FIELD_ASSIGNED_USER: 'Internal Assigned User',
	DETAILS_ACTIVITIES_FIELD_ASSIGNED_USER_2: 'External Assigned User',
	DETAILS_ACTIVITIES_FIELD_ASSIGNED_GROUP: 'Assigned Group',
	DETAILS_ACTIVITIES_FIELD_DATE_FROM: 'Availability date',
	DETAILS_ACTIVITIES_FIELD_DATE_TO: 'Expiring date',
	DETAILS_ACTIVITIES_FIELD_DATE_START: 'Start date',
	DETAILS_ACTIVITIES_FIELD_DATE_END: 'End date',
	DETAILS_ACTIVITIES_FIELD_LENGTH_HOURS: 'Expected hours',
	DETAILS_ACTIVITIES_FIELD_LENGTH_MINUTES: 'Expected minutes',
	DETAILS_ACTIVITIES_FIELD_TAGS: 'Tags',
	DETAILS_ACTIVITIES_FIELD_WARNING: 'Warning',
	DETAILS_ACTIVITIES_FIELD_BLOCKED: 'Blocked'
	// #endregion
};

export default locale;
